module.exports = __webpack_public_path__ + "img/brand-rackspace.a2360f02.svg";